import { useRecoilState } from 'recoil'

import useInitLoggedInDataQuery from '@src/hooks/queries/auth/initLoggedInData/useInitLoggedInDataQuery'
import vendorAtom from '@src/atom/vendor'
import { useEffect } from 'react'

const useInitLoggedInData = () => {
	const [vendorInfo, setVendorInfo] = useRecoilState(vendorAtom)

	const queryData = {
		show_vendor_info: true,
	}
	const { data: initLoggedInData } = useInitLoggedInDataQuery(
		{
			no: vendorInfo.no,
			queryData,
		},
		{
			enabled: !!vendorInfo.no,
			retry: false,
		},
	)

	useEffect(() => {
		if (!initLoggedInData) return
		const { vendor } = initLoggedInData.data
		setVendorInfo((vendorData) => ({
			...vendorData,
			profileImg: vendor.vendor_info.profile_img,
			brandName: vendor.vendor_info.name,
			description: vendor.vendor_info.company_description,
		}))
	}, [initLoggedInData, setVendorInfo])
}

export default useInitLoggedInData
